import { jsxs, jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { PRIMARY_COLOR } from "../../foundations/constants.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import { forwardRef } from "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { AngleDownSmallOutlined as i } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/angle-down-small-outlined.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { DEFAULT_ELEVATION } from "../../foundations/elevations.es.js";
import MUISelect from "../../../node_modules/@mui/material/Select/Select.es.js";
import MUIFormControl from "../../../node_modules/@mui/material/FormControl/FormControl.es.js";
import MUIInputLabel from "../../../node_modules/@mui/material/InputLabel/InputLabel.es.js";
import FormHelperText from "../../../node_modules/@mui/material/FormHelperText/FormHelperText.es.js";
const SELECT_MAX_HEIGHT = "13.56rem";
const SELECT_MIN_WIDTH = "11.25rem";
const Select = forwardRef(function Select2({
  children,
  error,
  size,
  helperText,
  label,
  labelId,
  fullWidth,
  ...rest
}, ref) {
  return /* @__PURE__ */ jsxs(MUIFormControl, { error, size, fullWidth, children: [
    /* @__PURE__ */ jsx(MUIInputLabel, { id: labelId, children: label }),
    /* @__PURE__ */ jsx(MUISelect, { ref, color: PRIMARY_COLOR, variant: "outlined", error, label, labelId, IconComponent: i, sx: {
      minWidth: SELECT_MIN_WIDTH,
      ...rest.sx
    }, MenuProps: {
      slotProps: {
        paper: {
          sx: {
            boxShadow: DEFAULT_ELEVATION,
            maxHeight: SELECT_MAX_HEIGHT
          }
        }
      },
      ...rest.MenuProps
    }, ...rest, children }),
    helperText && /* @__PURE__ */ jsx(FormHelperText, { children: helperText })
  ] });
});
export {
  Select
};
//# sourceMappingURL=select.es.js.map
